// src/components/Loading.js
import React from 'react';
import styles from '../styles/Loading.module.css'; // 新建样式文件

const Loading = () => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default Loading;